import mailIcon from "../assets/mail.svg";
import githubIcon from "../assets/github-svgrepo-com.svg";
import linkedinIcon from "../assets/linkedin-02-stroke-rounded.svg";
import whatsappIcon from "../assets/whatsapp.svg";

export const iconsInfo = [
  {
    label: "Email",
    value: "raja@rajaomar.me",
    href: "mailto:raja@rajaomar.me",
    icon: mailIcon,
  },
  {
    label: "GitHub",
    value: "rajaomar99",
    href: "https://github.com/rajaomar99",
    icon: githubIcon,
  },
  {
    label: "LinkedIn",
    value: "rajaomar-dev",
    href: "https://pk.linkedin.com/in/rajaomar-dev",
    icon: linkedinIcon,
  },
  {
    label: "WhatsApp",
    value: "+92 310 4134562",
    href: "https://wa.me/923104134562",
    icon: whatsappIcon,
  }
];
